"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var grid_1 = __importDefault(require("../grid"));
var detail_simple_1 = __importDefault(require("../detail-simple"));
var password_1 = __importDefault(require("../../ui/business/password"));
var ProfilePage = function (_a) {
    var data = _a.data, updateProfilePromise = _a.updateProfilePromise, updatePasswordPromise = _a.updatePasswordPromise, extraFields = _a.extraFields;
    var fields = [
        {
            name: 'firstName',
            label: 'First Name',
            type: 'string'
        },
        {
            name: 'lastName',
            label: 'Last Name',
            type: 'string'
        }
    ];
    if (extraFields) {
        if (extraFields.phone) {
            fields.push({
                name: 'phone',
                label: 'Phone',
                type: 'string'
            });
        }
        if (extraFields.company) {
            fields.push({
                name: 'company',
                label: 'Company',
                type: 'string'
            });
        }
    }
    var cells = [
        {
            Component: (react_1["default"].createElement(detail_simple_1["default"], { data: data, fields: fields, promise: updateProfilePromise })),
            title: 'Profile Update'
        },
        {
            Component: react_1["default"].createElement(password_1["default"], { update: updatePasswordPromise }),
            title: 'Password Update'
        }
    ];
    return react_1["default"].createElement(grid_1["default"], { cells: cells });
};
exports["default"] = ProfilePage;
